import PropTypes from 'prop-types';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';

export default function UpperCaseTextField({ name, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={field.value}
          onChange={(event) => {
            const inputValue = event.target.value;
            const upperCaseValue = inputValue.toUpperCase();
            field.onChange(upperCaseValue);
          }}
          error={!!error}
          helperText={error ? error.message : helperText}
          {...other}
        />
      )}
    />
  );
}

UpperCaseTextField.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string,
};
